export const announcementEventTypeOptions = [
  { value: "Classroom Session", label: "Classroom Session" },
  { value: "Coffee & Learn Session", label: "Coffee & Learn Session" },
  { value: "MuleSoft Meetups", label: "MuleSoft Meetups" },
  { value: "Salesforce Session", label: "Salesforce Session" },
  {
    value: "Executive Education Session",
    label: "Executive Education Session",
  },
  { value: "Display Announcement", label: "Display Announcement" },
];

const sqeAnnouncementEventTypeOptions = [
  {
    value: "Knowledge Sharing In-house Session",
    label: "Knowledge Sharing In-house Session",
  },
  { value: "External Session", label: "External Session" },
  { value: "Salesforce Session", label: "Salesforce Session" },
  { value: "Mulesoft Session", label: "Mulesoft Session" },
];

export const getAnnouncementEventTypeOptions = (isSqeLabs) =>
  isSqeLabs ? sqeAnnouncementEventTypeOptions : announcementEventTypeOptions;
